var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DataEditor',{key:_vm.pattern,staticClass:"enum-option-editor",attrs:{"uimodel":_vm.enumOptionsModel},on:{"restore":_vm.restore},model:{value:(_vm.enumOptions),callback:function ($$v) {_vm.enumOptions=$$v},expression:"enumOptions"}})}
var staticRenderFns = []

export { render, staticRenderFns }